<template>
  <div class="match-status">
    <div v-if="statusGroup.includes('live')" class="match-status__live">
      Матч идет в данный момент
    </div>

    <div v-else-if="dateToShow" class="match-status__date">
      {{ statusDescription }}
      <span>{{ dateToShow | dayjs("DD MMMM YYYY") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MatchStatus",
  props: {
    match: {
      type: Object,
      required: true
    },
    description: {},
    statusGroup: {}
  },
  computed: {
    dateToShow() {
      return this.match.ended_at || this.match.starts_at;
    },
    statusDescription() {
      return (this.description && this.description.status) || null;
    }
  }
};
</script>

<style lang="scss">
.match-status {
  font-size: 12px;
  line-height: 16px;

  &__date {
    color: #757987;

    span {
      font-weight: bold;
      color: #fff;
    }
  }

  &__live {
    color: #fff;
    background: #e72f31;
    box-shadow: 0px 0px 10px #ff0000;
    border-radius: 2px;
    padding: 4px 15px 5px 15px;
    display: inline-block;
  }
}
</style>
